module.exports = __webpack_public_path__ + "static/media/kts03.f192dcb8.png";